export const BASE_AVATAR_SIZE_PARAMS = {
  width: 48,
  height: 48
};